export const hasAny = (arr, keys) =>
  arr && arr.length > 0 && arr.some((item) => keys.some((k) => (item[k] || "").toString().trim()));

export const nonEmptyBullets = (bullets) =>
  (bullets || []).filter((b) => (b || "").toString().trim());

export const fmtRange = (start, end) => {
  const s = (start || "").trim();
  const e = (end || "").trim();
  if (!s && !e) return "";
  if (!s) return e;
  if (!e) return s;
  return `${s} — ${e}`;
};

export const joinContact = (personal) => {
  const parts = [];
  if (personal.email) parts.push(personal.email);
  if (personal.phone) parts.push(personal.phone);
  if (personal.location) parts.push(personal.location);
  return parts.filter(Boolean).join(" · ");
};

export const joinLinks = (personal) => {
  const parts = [];
  if (personal.website) parts.push(personal.website);
  if (personal.linkedin) parts.push(personal.linkedin);
  if (personal.github) parts.push(personal.github);
  return parts.filter(Boolean).join(" · ");
};

/**
 * Maps a section title/label to a stable per-category typography marker.
 * Each template's Section helper spreads the resulting object onto its
 * outer <section> element, so the injected scoped CSS in ResumePreview
 * can target every category independently (Summary/Description, Skills,
 * Education, Projects, Certifications, Additional Sections).
 *
 * Experience is intentionally excluded because its two child categories
 * (jobtitle / company) are already tagged inline at the entry level.
 * Titles that don't map to a known category return {} so the section
 * renders unchanged (no attribute noise).
 */
export const getSectionMarkerAttrs = (title) => {
  const key = (title || "").toString().toLowerCase().trim();
  if (!key) return {};
  const includes = (...needles) => needles.some((n) => key.includes(n));
  // Summary — Creative uses 'Statement', others use 'Summary/Profile/About'.
  if (includes("summary", "statement", "profile", "about")) return { "data-resume-description": "true" };
  // Skills — must catch 'Skills', 'Core Skills', 'Technical Skills', etc.
  if (includes("skill")) return { "data-resume-skills": "true" };
  // Education — catches 'Education', 'Academic Background', etc.
  if (includes("educat", "academic")) return { "data-resume-education": "true" };
  // Projects — catches 'Projects', 'Selected Projects', 'Featured Projects'.
  if (includes("project")) return { "data-resume-projects": "true" };
  // Certifications — catches 'Certifications', 'Licenses & Certifications'.
  if (includes("certif", "license")) return { "data-resume-certifications": "true" };
  // Additional Sections — catches Languages, Awards, Interests, References, etc.
  if (includes(
    "language", "award", "honor", "interest", "hobb", "reference",
    "publication", "activit", "volunteer", "extracurricular"
  )) return { "data-resume-additional": "true" };
  return {};
};
